import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe, CommonModule } from '@angular/common';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Options-Symbol-Columns.json';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { HttpErrorResponse } from '@angular/common/http';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { UserService } from 'app/Shared/Services/user.service';
import { Subscription } from 'rxjs';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { GridComponent } from 'app/Shared/Modules/non-transactional-grid/grid/grid.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";

@Component({
    selector: 'app-options-symbol',
    imports: [FilterPanelComponent, GridComponent, CommonModule, MatProgressSpinner, QuickSearchComponent],
    templateUrl: 'options-symbol.component.html',
    styleUrls: ['options-symbol.component.scss']
})

export class OptionsSymbolComponent implements OnInit, OnDestroy {

  quickFilterArray: any = GridColumnsJSON["option-symbol-quick-search-fields"];
  GridColumns = GridColumnsJSON["option-symbol-grid-columns"];
  panelOpenState: boolean;
  dataset1: any[] = [];
  LastExecutionCATDate!: any[];
  DefaultFilterArray: any = [];
  isLoadingResults = true;

  Limit: any = { 'Start': '', 'End': '' };
  totalRecords: any;
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  subscription!: Subscription;
  constructor(
    private gridService: GridService,
    private emitterService: EmitterService,
    public userService: UserService,
    private datePipe: DatePipe) {
        this.panelOpenState = false;
  }

  ngOnInit(): void {
    this.rowcount = this.gridService.getGridRowsCount();
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.totalRecords = this.rowcount;
    this.dataset1 = [];
    this.defaultFilter();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
  }

  updateDefaultArray($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.getData();
  }

  FilterApplyFilterEvent(event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.getData();
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }

  defaultFilter() {
    this.LastExecutionCATDate = [];
    this.LastExecutionCATDate.push(this.userService.optionSymbolDate); // Fromdate
    this.LastExecutionCATDate.push(this.userService.optionSymbolDate); // Todate

      this.DefaultFilterArray = [
        { 'isdefault':  'true', 'label': 'Date', 'columnname': 'Str_to_date', 'filterby': '', 'values':
        this.LastExecutionCATDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
        { 'isdefault':  'true', 'label': 'Option ID', 'columnname': 'optionID', 'filterby': 'IS', 'values': '', 'time': '',
        'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
        { 'isdefault': 'true', 'label': 'Primary Deliverable', 'columnname': 'primaryDeliverable', 'filterby': 'IS', 'values': '', 
        'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
      ];

    
    this.getData();
  }

  getData() {
    this.isLoadingResults = true;
    this.gridService.prepareData(APIURL.Options_Symbol, this.DefaultFilterArray, this.Limit, 'Options-Symbol')
      .subscribe({
        next: (Element:any) => {
        this.isLoadingResults = false;
        let dataset: any;
        dataset = Element;
        this.dataset1 = dataset.Data;
        this.totalRecords = dataset.totalCount;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
      },  error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
        this.dataset1 = [];
        this.totalRecords = 0;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
      }});
  }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}
